function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumberInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "var(--light-grey)",
    stroke: "var(--light-grey)",
    width: "100%",
    height: "100%",
    viewBox: "0 0 121 102",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Modus",
    transform: "matrix(1,0,0,1,0.0585,-5.05044)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.783673,7.10543e-15,16.1372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.679,11.149C119.679,5.66 115.223,1.204 109.734,1.204L11.149,1.204C5.66,1.204 1.204,5.66 1.204,11.149L1.204,90.713C1.204,96.202 5.66,100.658 11.149,100.658L109.734,100.658C115.223,100.658 119.679,96.202 119.679,90.713L119.679,11.149Z",
    style: {
      fill: "none",
      strokeWidth: "2.41px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.93802,0,0,3.93802,-31.5353,-69.8848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.572,27.515L16.98,27.515L16.98,36.419L16.284,36.419L16.284,28.433L14.598,29.693L14.598,28.985L16.572,27.515Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.402,35.783L24.402,36.419L20.052,36.419L20.052,36.017L22.29,32.423C22.654,31.843 22.914,31.343 23.07,30.923C23.226,30.503 23.304,30.097 23.304,29.705C23.304,29.117 23.158,28.696 22.866,28.442C22.574,28.188 22.136,28.061 21.552,28.061C20.988,28.061 20.454,28.171 19.95,28.391L19.95,27.749C20.158,27.653 20.414,27.576 20.718,27.518C21.022,27.46 21.318,27.431 21.606,27.431C22.374,27.431 22.967,27.607 23.385,27.959C23.803,28.311 24.012,28.863 24.012,29.615C24.012,30.079 23.929,30.547 23.763,31.019C23.597,31.491 23.306,32.057 22.89,32.717L20.958,35.783L24.402,35.783Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.448,31.799C30.068,31.935 30.539,32.2 30.861,32.594C31.183,32.988 31.344,33.489 31.344,34.097C31.344,34.613 31.234,35.053 31.014,35.417C30.794,35.781 30.479,36.057 30.069,36.245C29.659,36.433 29.17,36.527 28.602,36.527C27.946,36.527 27.336,36.423 26.772,36.215L26.772,35.591C27.06,35.699 27.36,35.78 27.672,35.834C27.984,35.888 28.288,35.915 28.584,35.915C29.24,35.915 29.748,35.76 30.108,35.45C30.468,35.14 30.648,34.685 30.648,34.085C30.648,33.477 30.463,33.006 30.093,32.672C29.723,32.338 29.162,32.171 28.41,32.171L27.708,32.171L27.708,31.547L28.044,31.547C28.548,31.547 28.974,31.47 29.322,31.316C29.67,31.162 29.933,30.944 30.111,30.662C30.289,30.38 30.378,30.045 30.378,29.657C30.378,29.117 30.227,28.713 29.925,28.445C29.623,28.177 29.17,28.043 28.566,28.043C27.974,28.043 27.426,28.153 26.922,28.373L26.922,27.749C27.134,27.653 27.393,27.576 27.699,27.518C28.005,27.46 28.308,27.431 28.608,27.431C29.408,27.431 30.019,27.619 30.441,27.995C30.863,28.371 31.074,28.913 31.074,29.621C31.074,30.149 30.933,30.605 30.651,30.989C30.369,31.373 29.968,31.643 29.448,31.799Z",
    style: {
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberInput);
export default __webpack_public_path__ + "static/media/numberInput.5acf6050216a79595f08ca1a558ed9b2.svg";
export { ForwardRef as ReactComponent };